import { createFileRoute } from '@tanstack/react-router';

import { PlatformSettingsLayout } from '@/layouts/admin/PlatformSettingsLayout';

export const Route = createFileRoute('/admin/_app/platform-settings')({
  component: PlatformSettingsLayout,
});
